<template>
  <div class="content">
    <headerNavbar title="文章资讯"></headerNavbar>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="article-wrapper">
        <div v-for="(item,index) in articles" :key="item.id">
          <router-link :to="{path:'/article',query:{id:item.id}}" class="article-row">
            <div class="article-content">
              <div class="article-title">{{item.title}}</div>
              <div class="article-footer">
                <span style="width:60px">{{item.article_type_name}}</span>
                <span>{{item.visit_count}}查看</span>
                <span>{{item.update_time|fromNow}}</span>
              </div>
            </div>
            <div class="article-img" v-if="item.cover_url"></div>
          </router-link>
        </div>
      </div>
    </van-list>

  </div>
</template>

<style lang="less" scope="">
  html,
  body {
    height: 100%;
  }

  #app {
    height: 100%;
  }

  .content {
    background: #ffffff;
    min-height: 100%;
  }

  .article-wrapper {
    padding: 12px;

    .article-row {
      display: flex;
      padding: 10px 0px;
      margin: 10px 8px;
      border-bottom: 1px solid #f2f2f2;

      .article-img {
        margin-left: 20px;
        width: 80px;
        height: 80px;
        background: #eeeeee;
      }

      .article-content {
        flex: 1;

        .article-title {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 10px;
        }

        .article-footer {
          color: #969799;
          font-size: 12px;

          span {
            margin-right: 20px;
          }
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue';
  import {
    List
  } from 'vant';
  Vue.use(List);
  import headerNavbar from '../components/headerNavbar'
  import {
    getArticles
  } from "@/api/article";
  export default {
    components: {
      headerNavbar,
    },
    data() {
      return {
        tabIndex: 0,
        articleCates: [{
            title: "热门",
            code: "hot"
          },
          {
            title: "新闻公告",
            code: "news"
          },
          {
            title: "健康知识",
            code: "health"
          }
        ],
        articles: [],
        loading: false,
        finished: false,
        offset: 0,
      };
    },
    methods: {
      onLoad() {
        let hospId = this.$route.query.hospid;
        let cate = "";

        getArticles(hospId, cate, this.offset).then(res => {
          if (res.data && res.data.length > 0) {
            this.articles.push(...res.data);
          } else {
            this.finished = true;
          }
          this.offset += 10;
          this.loading = false;
        });
      }
    },
  };
</script>